<template>
  <div :class="['guest_item',type==='two'?' two_guest_item':'']">
    <div
      class="content_wrapper"
      :style="{background:`#FFF url(${rightArrow}) right top / auto 30vh no-repeat`}"
    >
      <div class="title_wrapper">
        <img class="title" :src="title" />
        <div class="show_time">{{show_time}}</div>
      </div>
      <div class="guest_avatar_wrapper">
        <div class="avatar_warpper">
          <img class="avatar" :src="avatar1" />
          <div v-if="identity1" class="identity">{{identity1}}</div>
          <div :class="['name' ,name1&&name1.length > 4?' five_name':'']">{{name1}}</div>
          <div v-if="id1" class="id">{{id1}}</div>
          <div v-if="achievement1" class="achievement_wrapper">
            <div class="achievement">{{achievement1}}</div>
            <div class="sub_achievement">{{sub_achievement1}}</div>
          </div>
        </div>
        <div v-if="avatar2" class="avatar_warpper avatar_two">
          <img class="avatar" :src="avatar2" />
          <div class="identity">{{identity2}}</div>
          <div :class="['name' ,name2&&name2.length > 4?' five_name':'']">{{name2}}</div>
          <div v-if="id2" class="id">{{id2}}</div>
          <div class="achievement_wrapper">
            <div class="achievement">{{achievement2}}</div>
            <div class="sub_achievement">{{sub_achievement2}}</div>
          </div>
        </div>
      </div>
      <div :class="['slogan',slogan&&slogan.length>=16&&type==='one'?' min_slogan':'']">
        <div class="slogan_text">{{slogan}}</div>
        <div v-if="vSrc">
          <img
            @click="playCurVideo(vSrc)"
            class="play_btn"
            alt="播放视频"
            src="https://summit-img.geekpark.net/r2020/play_btn.svg"
          />
        </div>
      </div>
    </div>
    <div class="bg_border"></div>
  </div>
</template>

<script>
export default {
  name: "GuestItem",
  props: {
    type: "",
    title: "",
    show_time: "",
    rightArrow: "",
    slogan: "",
    avatar1: "",
    identity1: "",
    name1: "",
    id1: "",
    achievement1: "",
    sub_achievement1: "",
    avatar2: "",
    identity2: "",
    name2: "",
    id2: "",
    achievement2: "",
    sub_achievement2: "",
    vSrc: "",
  },
  computed: {
    curVideoSrc() {
      return this.$store.state.curVideoSrc;
    },
  },
  methods: {
    playCurVideo(vSrc) {
      if (!vSrc) return;
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      if (vIframeWrapper.style.display === "none") {
        vIframeWrapper.style.display = "block";
        vIframe.src = this.vSrc;
        this.$store.commit("handleVSrcToggle", this.vSrc);
      } else {
        if (vSrc === this.curVideoSrc) return;
        vIframe.src = this.vSrc;
        this.$store.commit("handleVSrcToggle", this.vSrc);
      }
    },
  },
};
</script>

<style scoped lang="less">
.guest_item {
  position: relative;
  height: 42vh;
  width: 44vh;
  background: #fff;
  margin-right: 36px;
  &.two_guest_item {
    width: 86vh;
  }
  .content_wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #000;
    background: #fff;
    z-index: 3;
    padding-top: 8px;
    .title_wrapper {
      padding: 0px 16px;
      height: 5vh;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        height: 5vh;
        width: auto;
      }
      .show_time {
        font-family: "ParaTypeStapelExtraBold";
        font-size: 4vh;
        font-weight: bold;
      }
    }
    .guest_avatar_wrapper {
      display: flex;
      justify-content: center;
      .avatar_warpper {
        padding-top: 2px;
        position: relative;
        &.avatar_two {
          margin-left: 10px;
        }
        .avatar {
          height: 25vh;
          width: auto;
          border: 1px solid #000;
        }
        .identity {
          position: absolute;
          top: 5vh;
          left: 21vh;
          height: 3vh;
          color: #fff;
          background: #000;
          padding: 1vh 1.5vh;
          text-align: center;
          line-height: 1vh;
          font-size: 1vh;
          font-weight: bold;
        }
        .name {
          position: absolute;
          top: 8vh;
          left: 21vh;
          font-size: 4vh;
          font-weight: bold;
          &.five_name {
            font-size: 3vh;
          }
        }
        .id {
          position: absolute;
          top: 14vh;
          left: 21vh;
          font-size: 2vh;
          font-weight: bold;
        }
        .achievement_wrapper {
          width: 20vh;
          border: 1px solid #000;
          background: #fff;
          position: absolute;
          left: 20vh;
          bottom: 0;
          padding: 6px;
          .achievement {
            font-size: 1.6vh;
            font-weight: bold;
            line-height: 1.4em;
          }
          .sub_achievement {
            font-size: 1vh;
          }
        }
      }
    }
    .slogan {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 3vh;
      font-weight: bold;
      line-height: 1.1em;
      height: 9vh;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0px 16px;
      &.min_slogan {
        font-size: 2.7vh;
      }
      .slogan_text {
        flex: 1;
        padding-right: 10px;
      }
      .play_btn {
        height: 5vh;
        width: auto;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .bg_border {
    width: 100%;
    height: 100%;
    border: 1px solid #000;
    background: #fff;
    position: absolute;
    top: 6px;
    left: 6px;
    z-index: 2;
  }
}
</style>